import * as $ from "jquery";

export const NipRule = (() => {
	$.validator.addMethod("nip", function (value) {
		let orgValue = value;
		value = value.replace(/[^0-9]/g, "");

		if (value !== orgValue) {
			return false;
		}

		if(value.length === 10) {
			let nip_weight_table = [6, 5, 7, 2, 3, 4, 5, 6, 7];
			let sum = 0;

			for(let i = 0; i < nip_weight_table.length; i++ ) {
				sum += value.charAt(i) * nip_weight_table[i];
			}

			let last_number = sum % 11

			if(parseInt(value.charAt(9)) === last_number) {
				return /^[0-9]{10}$/.test(value);
			}
		}
	},
	$.validator.format("Numer NIP jest niepoprawny "));
})();import * as $ from "jquery";

export const NipRule = (() => {
	$.validator.addMethod("nip", function (value) {
		let orgValue = value;
		value = value.replace(/[^0-9]/g, "");

		if (value !== orgValue) {
			return false;
		}

		if(value.length === 10) {
			let nip_weight_table = [6, 5, 7, 2, 3, 4, 5, 6, 7];
			let sum = 0;

			for(let i = 0; i < nip_weight_table.length; i++ ) {
				sum += value.charAt(i) * nip_weight_table[i];
			}

			let last_number = sum % 11

			if(parseInt(value.charAt(9)) === last_number) {
				return /^[0-9]{10}$/.test(value);
			}
		}
	},
	$.validator.format("Numer NIP jest niepoprawny "));
})();